/* MUVNA Studio — interacciones mínimas: menú móvil, filtros, orden, favoritos, revelado, tira horizontal. */
(function () {
  document.documentElement.classList.add('loaded');

  /* Menú móvil */
  var burger = document.getElementById('MenuToggle');
  var menu = document.getElementById('MobileMenu');
  var overlay = document.getElementById('MobileMenuOverlay');
  var closeBtn = document.querySelector('[data-menu-close]');
  function setMenu(open) {
    if (!menu) return;
    menu.classList.toggle('is-open', open);
    if (overlay) overlay.classList.toggle('is-open', open);
    if (burger) burger.setAttribute('aria-expanded', open ? 'true' : 'false');
    document.body.classList.toggle('menu-open', open);
    if (open) { var f = menu.querySelector('input,a,button'); if (f) f.focus(); } else if (burger) { burger.focus(); }
  }
  if (burger && menu) burger.addEventListener('click', function () { setMenu(!menu.classList.contains('is-open')); });
  if (overlay) overlay.addEventListener('click', function () { setMenu(false); });
  if (closeBtn) closeBtn.addEventListener('click', function () { setMenu(false); });
  document.querySelectorAll('.mobile-menu__expand').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var item = btn.closest('.mobile-menu__item');
      var open = item.classList.toggle('is-expanded');
      btn.setAttribute('aria-expanded', open ? 'true' : 'false');
    });
  });
  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Escape') return;
    if (menu && menu.classList.contains('is-open')) setMenu(false);
    closeFilters();
  });

  /* Favoritos (misma clave que la ficha de producto) */
  function getWl() { try { return JSON.parse(localStorage.getItem('muvna_wishlist') || '[]'); } catch (e) { return []; } }
  function setWl(l) { try { localStorage.setItem('muvna_wishlist', JSON.stringify(l)); } catch (e) {} }
  document.querySelectorAll('[data-card-wishlist-btn]').forEach(function (btn) {
    var pid = btn.getAttribute('data-product-id');
    if (getWl().indexOf(pid) > -1) { btn.classList.add('is-active'); btn.setAttribute('aria-pressed', 'true'); }
    btn.addEventListener('click', function (e) {
      e.preventDefault(); e.stopPropagation();
      var l = getWl(), i = l.indexOf(pid);
      if (i > -1) { l.splice(i, 1); btn.classList.remove('is-active'); btn.setAttribute('aria-pressed', 'false'); }
      else { l.push(pid); btn.classList.add('is-active'); btn.setAttribute('aria-pressed', 'true'); }
      setWl(l);
    });
  });

  /* Feedback de añadir rápido (la petición la gestiona muvna-cart-drawer.js) */
  document.addEventListener('submit', function (evt) {
    var form = evt.target;
    if (!form.matches || !form.matches('[data-quick-add-form]')) return;
    var btn = form.querySelector('button[type=submit]');
    if (!btn) return;
    var old = btn.getAttribute('data-label') || btn.textContent;
    btn.setAttribute('data-label', old);
    btn.textContent = 'Añadido';
    form.closest('.card__quick').classList.add('is-added');
    setTimeout(function () { btn.textContent = old; form.closest('.card__quick').classList.remove('is-added'); }, 1400);
  }, true);

  /* Filtros de colección (panel móvil) */
  var fToggle = document.querySelector('[data-filters-toggle]');
  var fPanel = document.querySelector('[data-filters-panel]');
  var fClose = document.querySelector('[data-filters-close]');
  var fOverlay = document.querySelector('[data-filters-overlay]');
  function closeFilters() {
    if (fPanel) fPanel.classList.remove('is-open');
    if (fOverlay) fOverlay.classList.remove('is-open');
    if (fToggle) fToggle.setAttribute('aria-expanded', 'false');
  }
  if (fToggle && fPanel) fToggle.addEventListener('click', function () {
    fPanel.classList.add('is-open'); if (fOverlay) fOverlay.classList.add('is-open');
    fToggle.setAttribute('aria-expanded', 'true');
    var f = fPanel.querySelector('input,button'); if (f) f.focus();
  });
  if (fClose) fClose.addEventListener('click', closeFilters);
  if (fOverlay) fOverlay.addEventListener('click', closeFilters);

  /* Orden */
  var sort = document.querySelector('[data-sort-select]');
  if (sort) sort.addEventListener('change', function () {
    var u = new URL(window.location.href); u.searchParams.set('sort_by', sort.value); u.searchParams.delete('page'); window.location.href = u.toString();
  });

  /* Filtros de rango de precio: enviar al pulsar Enter o "Aplicar" */
  var priceForm = document.getElementById('CollectionFilterForm');
  if (priceForm) priceForm.addEventListener('submit', function (e) {
    e.preventDefault();
    var u = new URL(window.location.href);
    priceForm.querySelectorAll('input[type=number]').forEach(function (i) {
      if (i.value) u.searchParams.set(i.name, i.value); else u.searchParams.delete(i.name);
    });
    u.searchParams.delete('page');
    window.location.href = u.toString();
  });

  /* Tira horizontal con flechas */
  document.querySelectorAll('[data-strip]').forEach(function (wrap) {
    var track = wrap.querySelector('[data-strip-track]');
    var prev = wrap.querySelector('[data-strip-prev]');
    var next = wrap.querySelector('[data-strip-next]');
    if (!track) return;
    function step() { return Math.max(240, track.clientWidth * 0.8); }
    if (prev) prev.addEventListener('click', function () { track.scrollBy({ left: -step(), behavior: 'smooth' }); });
    if (next) next.addEventListener('click', function () { track.scrollBy({ left: step(), behavior: 'smooth' }); });
  });

  /* Revelado al hacer scroll */
  var els = document.querySelectorAll('.reveal');
  if ('IntersectionObserver' in window && els.length) {
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) { if (en.isIntersecting) { en.target.classList.add('is-in'); io.unobserve(en.target); } });
    }, { threshold: 0.08, rootMargin: '0px 0px -30px 0px' });
    els.forEach(function (el) { io.observe(el); });
  } else { els.forEach(function (el) { el.classList.add('is-in'); }); }
})();